import React from 'react';
import Form from './Form';

const Card = ({ actions, headerName }) => (
    <div className="card">
        <div className="card-header">
            <div className="row align-items-center">
                <div className="col-12">
                    <h3 className="mb-0">{headerName}</h3>
                </div>
            </div>
        </div>
        <div className="card-body">
            <Form actions={actions} />
        </div>
    </div>
);

export default Card;


// WEBPACK FOOTER //
// ./src/components/Pages/Establishments/Management/Card.js